// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let EntitlmentDocument = function (id, name, content)
{
    this.Id = id;
    this.Name = name;
    this.Content = content;
}